import './TitleBar.scss';

import { ArchiveButton } from './ArchiveButton';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { EditOutlined } from '@ant-design/icons';
import { SonarText } from '@ui/text';
import { When } from 'react-if';

import { Button, Row, Space } from 'antd';
import React, { useCallback, useState } from 'react';
import { useAction, useCurrentUser } from '@hooks';

export interface InitiativeTitleBarProps {
	initiativeId: number;
	title: string | null | undefined;
}

export const InitiativeTitleBar: React.FC<InitiativeTitleBarProps> = ({ initiativeId, title }) => {
	const { isReadOnly } = useCurrentUser();
	const [ isEditing, setIsEditing ] = useState(false);
	const patchInitiative = useAction(coreActions.requestPatchCoreInitiativesById);

	const handleCancel = useCallback(() => {
		setIsEditing(false);
	}, []);

	const handleEditClick = useCallback(() => {
		setIsEditing(true);
	}, []);

	const handleChange = useCallback(
		(updatedTitle: string) => {
			if (updatedTitle !== title) {
				patchInitiative({
					initiativeId: initiativeId,
					patchInitiativeDescription: {
						title: updatedTitle
					}
				});
			}
			setIsEditing(false);
		},
		[ initiativeId, patchInitiative, title ]
	);

	return (
		<Row
			align='middle'
			className='initiative-title-bar'
			justify='space-between'
			wrap={ false }>
			<SonarText
				className='title h1'
				editable={ {
					editing: isEditing,
					icon: <div />,
					maxLength: 60,
					onCancel: handleCancel,
					onChange: handleChange,
					tooltip: false
				} }
				ellipsis>
				{ title }
			</SonarText>
			<When condition={ !isEditing && !isReadOnly }>
				<div className='actions'>
					<Space>
						<ArchiveButton initiativeId={ initiativeId } />
						<Button
							icon={ <EditOutlined /> }
							id='initiative-rename-button'
							onClick={ handleEditClick }>
							{ COPY_SPECIFIC.RENAME }
						</Button>
					</Space>
				</div>
			</When>
		</Row>
	);
};
